import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "./components/theme/styling.css";
import { AuthProvider } from "./services/AuthContext";
import { LoadingManagerProvider } from "./services/LoadingManager";
import { NotificationProvider } from "./services/NotificationContext";

import App from "./App";
import { LoadingProvider } from "./services/LoadingContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <LoadingManagerProvider>
    <LoadingProvider>
      <AuthProvider>
        <NotificationProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </NotificationProvider>
      </AuthProvider>
    </LoadingProvider>
  </LoadingManagerProvider>
);
